import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { ItemStyles } from '../styles';
import { useKanban } from 'hooks/useKanban';

const Platform = ({ id, platform, active, icon, setStatus }) => {
  const { t: translate } = useTranslation();
  const { kanban: paidMedia } = useKanban();
  const [isActive, setIsActive] = useState(active);

  const handleChange = async (event) => {
    try {
      setIsActive(event.target.checked);
      await paidMedia.updateTypeItem('platforms', id, { enabled: event.target.checked });
    } catch (error) {
      setStatus('error');
      setIsActive(!event.target.checked);
      console.error('Failed to update platform status:', error);
    }
  };

  return (
    <ItemStyles className="justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-2">
        {icon && React.createElement(icon)}
        <span className="m-0">{platform}</span>
      </div>
      <Col lg="12" className="w-auto p-0">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
          }}
        >
          <div className="square-switch m-0 align-items-center d-flex">
            <input
              type="checkbox"
              id={`switch-${platform}`}
              data-switch="none"
              checked={isActive}
              onChange={handleChange}
            />
            <label
              className="m-0"
              htmlFor={`switch-${platform}`}
              data-on-label={translate('Yes')}
              data-off-label={translate('No')}
            />
          </div>
        </div>
      </Col>
    </ItemStyles>
  );
};

Platform.propTypes = {
  id: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  icon: PropTypes.elementType,
  setStatus: PropTypes.func.isRequired,
};

export default Platform;
